import styled from 'styled-components';
import { blue } from '../../../styles/Variables';
import { deviceMax } from '../../../styles/MediaQuery';

export const ContactDataWrapper = styled.div`
    max-width: 620px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin: 2.625rem auto 0 auto;

    @media ${deviceMax.tablet} {
        padding: 0 0.5rem;
    }

    * {
        margin: 0;
        padding: 0;
    }

    h2 {
        color: ${blue};
        font-size: 1.5rem;
        letter-spacing: 0.025em;
        margin: 0;
        margin-bottom: 0.6rem;
        line-height: 1.5rem;
    }

    p {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 1rem;

        strong {
            font-family: Arial, Helvetica, sans-serif;
            font-size: 1rem;
            font-weight: 700;
        }

        span {
            font-family: Arial, Helvetica, sans-serif;
            text-transform: capitalize;
        }

        a {
            text-decoration: none;
            color: ${blue};
        }
    }

    a {
        text-decoration: none;
        color: ${blue};
    }
`;
